export default __webpack_public_path__ + "static/media/googlebigquery.11f823a4.svg";